<div class="grid bg position-relative">
  <img
    class="fondo"
    src="../../../../assets/images/loginFondo.png"
    alt="Puerto Altamira"
  />
  <amplify-authenticator
    [hideSignUp]="true"
    [loginMechanisms]="['email']"
    [formFields]="formFields"
    translationKey="SignIn"
    class="auth-container"
    *ngIf="!loading"
  >
    <ng-template amplifySlot="sign-in-header">
      <div class="img-container-logo">
        <img
          class="amplify-image"
          alt="Amplify logo"
          src="/assets/images/CTS_MexGMD_Offset_Blk.png"
        />
      </div>
    </ng-template>
    <ng-template
      amplifySlot="authenticated"
      let-user="user"
      let-signOut="signOut"
    >
      <!-- <button routerLink="/bl-lista" class="btn-lote" style="margin: 0 auto">
        Ir a la página principal <i class="bi bi-arrow-right"></i>
      </button> -->
      <button (click)="signOut()" class="btn-lote" style="margin: 0 auto">
        Iniciar Sesión para comprobar la información
        <i class="bi bi-arrow-right"></i>
      </button>
    </ng-template>
  </amplify-authenticator>
</div>
<app-overlay
  *ngIf="loading"
></app-overlay>
<app-overlay
  *ngIf="errorOverlay"
  mensaje="Error con el servidor al cargar los permisos del usuario, inténtelo más tarde"
  icono="bi bi-exclamation-circle-fill"
></app-overlay>
